import PropTypes from 'prop-types';
import { Box, Button, Typography, Tooltip } from '@mui/material';
import { Iconify } from 'src/components';
import { sectionTabsContainerSx, sectionTabSx, sectionTabNumSx } from '../styles';

const SectionTabs = ({
  sections = [],
  currentSectionId,
  completedSections = [],
  sectionsWithSkipped = [],
  onSectionClick,
}) => (
  <Box sx={sectionTabsContainerSx}>
    {sections.map((section) => {
      const isActive = section.id === currentSectionId;
      const isCompleted = completedSections.includes(section.id);
      const hasSkipped = sectionsWithSkipped.includes(section.id);
      const isUnmatched = section.isUnmatched === true;

      return (
        <Button
          key={section.id}
          onClick={() => onSectionClick?.(section.id)}
          sx={{
            ...sectionTabSx(isActive, isCompleted, hasSkipped),
            ...(isUnmatched && {
              borderColor: 'rgba(255, 171, 0, 0.5)',
              '&:hover': {
                borderColor: 'rgba(255, 171, 0, 0.7)',
                bgcolor: 'rgba(255, 171, 0, 0.04)',
              },
              ...(isActive && {
                bgcolor: 'rgba(255, 171, 0, 0.08)',
                borderColor: '#FFAB00',
              }),
            }),
          }}
        >
          <Box
            sx={{
              ...sectionTabNumSx(isActive, isCompleted, hasSkipped),
              ...(isUnmatched && {
                bgcolor: isActive ? 'rgba(255, 171, 0, 0.16)' : 'rgba(255, 171, 0, 0.08)',
                color: '#B76E00',
              }),
            }}
          >
            {isCompleted && hasSkipped ? '!' : section.id}
          </Box>
          <Typography component="span" sx={{ fontSize: 'inherit', fontWeight: 'inherit' }}>
            {section.name}
          </Typography>
          {isUnmatched && (
            <Tooltip title="These fields are not in the current script version" arrow placement="top">
              <Box sx={{ display: 'flex', alignItems: 'center', ml: 0.5 }}>
                <Iconify
                  icon="mdi:alert-circle-outline"
                  width={14}
                  height={14}
                  sx={{ color: '#FFAB00' }}
                />
              </Box>
            </Tooltip>
          )}
        </Button>
      );
    })}
  </Box>
);

SectionTabs.propTypes = {
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      isUnmatched: PropTypes.bool,
    })
  ),
  currentSectionId: PropTypes.number,
  completedSections: PropTypes.arrayOf(PropTypes.number),
  sectionsWithSkipped: PropTypes.arrayOf(PropTypes.number),
  onSectionClick: PropTypes.func,
};

export default SectionTabs;
